import { t } from "@/i18n-js/instance";
import { useThemeContext } from "@circle-react/providers";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

interface SummarizeButtonProps {
  buttonSize?: number;
  onClick: () => void;
}

export const SummarizeButton = ({
  onClick,
  buttonSize = 28,
}: SummarizeButtonProps) => {
  const { isDarkAppearance } = useThemeContext();

  return (
    <TippyV2 content={t("post.summarize")} interactive={false}>
      <IconButton
        name={isDarkAppearance ? "20-stardust" : "20-stardust-gradient"}
        iconSize={20}
        className="group"
        iconClassName="group-hover:animate-spin-pause-reverse"
        onClick={onClick}
        buttonSize={buttonSize}
        ariaLabel={t("post.summarize")}
      />
    </TippyV2>
  );
};
